import commonEnHK from './common_en-HK'

const cheEnHK = {
  che: {
    ...commonEnHK,
  }
}

export default cheEnHK